import { InputFillMode as NumericTextBoxInputFillMode , InputRounded as NumericTextBoxInputRounded , InputSize as NumericTextBoxInputSize } from "@progress/kendo-angular-inputs";
export declare type InputFillMode = NumericTextBoxInputFillMode;
export declare type InputRounded = NumericTextBoxInputRounded;
export declare type InputSize = NumericTextBoxInputSize;